import { render, staticRenderFns } from "./AccrualsModule.vue?vue&type=template&id=5bb12101&"
import script from "./AccrualsModule.vue?vue&type=script&lang=js&"
export * from "./AccrualsModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports